import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const API_URL = new InjectionToken(
  'Retorna un string que representa el endpoint del api',
  {
    providedIn: 'root',
    factory: () => environment.BASE_URL,
  }
);

export const API_URL_CLOUDFRONT = new InjectionToken(
  'Retorna un string que representa el endpoint del api-cloudfront',
  {
    providedIn: 'root',
    factory: () => environment.API_CLOUDFRONT,
  }
);
